import { OpenInNew } from '@mui/icons-material'
import { GridRenderCellParams } from '@mui/x-data-grid'

import { ExternalLink } from '../../Link'

export const renderOrcidCell = (params: GridRenderCellParams) => {
  if (!params.value || params.value === ' ') return ''
  const orcidNumber = params.value.replace('http://orcid.org/', '')
  return (
    <ExternalLink href={`https://orcid.org/${params.value}`}>
      {orcidNumber} <OpenInNew sx={{ fontSize: 10 }} />
    </ExternalLink>
  )
}
